import React from 'react';
import PropTypes from 'prop-types';

/**
 * Heading Atom - komponenty nagłówków h1-h6
 */
const Heading = ({ 
  level = 1, 
  children, 
  className = '',
  variant = 'default',
  ...props 
}) => {
  const Tag = `h${level}`;
  
  const baseClasses = {
    1: 'text-4xl font-bold tracking-tight text-gray-900',
    2: 'text-3xl font-bold tracking-tight text-gray-900', 
    3: 'text-2xl font-semibold text-gray-900',
    4: 'text-xl font-semibold text-gray-900',
    5: 'text-lg font-medium text-gray-900',
    6: 'text-base font-medium text-gray-900'
  };

  const variantClasses = {
    default: '',
    subtitle: 'text-gray-600 font-normal',
    muted: 'text-gray-500',
    primary: 'text-primary-600'
  };

  const classes = [
    baseClasses[level],
    variantClasses[variant],
    className
  ].filter(Boolean).join(' ');

  return (
    <Tag className={classes} {...props}>
      {children}
    </Tag>
  );
};

Heading.displayName = 'Heading';

Heading.propTypes = {
  level: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'subtitle', 'muted', 'primary']),
};

export default Heading;
